import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-collapsible-section',
    templateUrl: './collapsible-section.component.html',
    styleUrls: ['./collapsible-section.component.scss'],
    standalone: false
})
export class CollapsibleSectionComponent {
  @Input() id = '';
  @Input() expanded = true;
  @Input() header = 'center';

  setExpanded(expand: boolean): void {
    this.expanded = expand;
  }

  onToggleExpanded(): void {
    this.expanded = !this.expanded;
  }
}
